import React, { useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';

// import { RowContainer, LabelTitle } from "./LabelTitle"

// import { Button } from "../ui/button"
import { useStore } from "../../lib/states"
// import { useClickAway, useToggle } from "react-use"
// import { Textarea } from "../ui/textarea"
import { 
  generateMask, 
  srcToFile,
} from "../../lib/utils"

import { useHookStore } from "../../hook-store/store"

import './DiffusionOptionsPreview.css';

const StyleChangePreview = () => {
  const [
    lastLineGroup,
    // lineGroups,
    curLineGroup,
    imageWidth,
    imageHeight,
    renders,
    file,
  ] = useStore((state) => [
    state.editorState.lastLineGroup,
    // state.editorState.lineGroups,
    state.editorState.curLineGroup,
    state.imageWidth,
    state.imageHeight,
    state.editorState.renders,
    state.file,
  ])

  const [t] = useTranslation('translation');

  const [hStore, hDispatch] = useHookStore();
  const { 
    // serverProcessing,
    // ipAdapterImage,
    // ipAdapterScale,
    // modelName,
    ipAdapterImages,
    // isIopaintServerExist,
   } = (hStore as any).iopaintStore;
  // const { 
  //   showToggleNav, 
  //   showInpaintSettings,
  //  } = (hStore as any).uiStore;

  const [targetFile, setTargetFile] = useState(file);

  useEffect(() => {
    setTargetFileHandler();
  },[]);

   const previewHeight = 150;
   const previewWidth = previewHeight * imageWidth / imageHeight 

   const previewImageStyle = {
    height: previewHeight, 
    width: previewWidth, 
   };

   const maskPreviewStyle = {
    height: previewHeight, 
    width: previewWidth, 
    border: "0.1px dashed gray",
  };

  const ipaImageStyle = {
    height: "150px", 
    width: "150px", 
    // objectFit: "fill"
  };


  let previewLineGroup = curLineGroup;

  if (curLineGroup.length === 0) {
    previewLineGroup = lastLineGroup
  }

  // const maskCanvas = generateMask(imageWidth, imageHeight, lineGroups)
  const maskCanvas = generateMask(imageWidth, imageHeight, [previewLineGroup])
  const hRef = maskCanvas.toDataURL("image/jpeg");

  // console.log('state mask', maskCanvas, hRef, curLineGroup);


  const setTargetFileHandler = async () => {
    let targetFile = file
    if (file && renders.length > 0) {
      const lastRender = renders[renders.length - 1]
      targetFile = await srcToFile(lastRender.currentSrc, file.name, file.type)
      setTargetFile(targetFile);
    }
    // return targetFile
  };

  return (
    <div>
      <div 
        className="doImagePreviewImages"
        // style={{ display: "flex", flexWrap: "wrap" }}
      >
        {file && targetFile && (
          <img 
          style={previewImageStyle}
            src={URL.createObjectURL(targetFile)}
          />
        )}
        <img 
          style={maskPreviewStyle}
          src={hRef}
        />

        {ipAdapterImages?.length > 0 && (
            <div>
            <ul>
                {ipAdapterImages.map((ipaImage: any) => {
                if (ipaImage.image) {
                    return (
                    <li key={ipaImage.id}>
                        <div className="">
                        <img className=""
                            style={ipaImageStyle}
                            src={URL.createObjectURL(ipaImage.image)}
                            // onLoad={getImgDimension}
                            alt="img prompt input"
                        />
                        {/* <span>
                            image-prompt
                        </span> */}
                        </div>
                    </li>
                    );
                }
                })}
            </ul>
            </div>
        )}
      </div>
    </div>
  )
}

export default StyleChangePreview
